import { authorizeDeleteRequest, authorizeGetRequest, authorizePostRequest } from "api";
import { IDataResponse, IPaginatedResponse } from "models";
import { ICreateNewsInput, INews, INewsBroadcastInput } from "models/broadcast";

export const newsBroadcastApi = async (input: INewsBroadcastInput) => {
  const data: { [key: string]: string | number[] } = {
    title: input.title,
    content: input.content,
    to: input.to,
  };

  // Only include driver filters if broadcasting to drivers
  if (input.to === "driver") {
    if (input.driver_age && input.driver_age.length === 2) {
      data.driver_age = input.driver_age as number[];
    }
    if (input.fleet_production_year && input.fleet_production_year.length === 2) {
      data.fleet_production_year = input.fleet_production_year as number[];
    }
  }

  console.log("📤 Broadcasting news to drivers/passengers");
  console.log("📤 Endpoint: POST notifications/news/broadcast");
  console.log("📤 Target audience:", input.to);
  console.log("📤 Request payload:", JSON.stringify(data, null, 2));

  try {
    const response = await authorizePostRequest<IDataResponse<INews>>(
      "notifications/news/broadcast",
      data
    );

    if (response.data) {
      console.log("✅ Broadcast API success - Backend should emit socket notification");
      console.log("✅ Response data:", response.data);
    } else if (response.error) {
      console.error("❌ Broadcast API error:", response.error);
      console.error("❌ Error message:", response.error.message);
      console.error("❌ Error status:", response.error.status);
    }

    return response;
  } catch (error) {
    console.error("❌ Exception calling broadcast API:", error);
    throw error;
  }
};

export const sendNewsApi = async (input: ICreateNewsInput) => {
  return authorizePostRequest<IDataResponse<INews>>(
    "notifications/news",
    input
  );
};

export const newsesApi = (page: number, perPage: number, search: string) => {
  return authorizeGetRequest<IPaginatedResponse<INews>>(
    `notifications/news?page=${page}&per_page=${perPage}&query=${search}`
  );
};

export const deleteNewsApi = (id: string) => {
  return authorizeDeleteRequest<IDataResponse<INews>>(`notifications/news/${id}`);
};
